module.exports = __webpack_public_path__ + "static/img/login_illustration.53dd901.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/login_illustration.png
// module id = nQrx
// module chunks = 1